import { render, staticRenderFns } from "./CSCompletedRequests.vue?vue&type=template&id=4d6346d8&scoped=true&"
import script from "./CSCompletedRequests.vue?vue&type=script&lang=js&"
export * from "./CSCompletedRequests.vue?vue&type=script&lang=js&"
import style0 from "./CSCompletedRequests.vue?vue&type=style&index=0&id=4d6346d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6346d8",
  null
  
)

export default component.exports